<template>
	<a-drawer title="编辑4G采集设备" :visible="showAddFlag"  width="480" @close="closeView(false)" :destroyOnClose='true' :maskClosable="false">
		<a-form-model ref="addForm"   :model="editModel"   :label-col="{ span: 5 }" :wrapper-col="{ span: 18 }" :rules="rules" >
			<a-form-model-item label="所属小区" prop="neighborId">
				<a-select v-model="editModel.neighborId" allowClear option-filter-prop="children"  :filter-option="filterOption" show-search>
					<a-select-option v-for="(item,index) in neighborList" :key="item.pId" :value="item.pId">{{item.neighborName}}</a-select-option>
				</a-select>
			</a-form-model-item>
			<a-form-model-item label="设备地址" prop="deviceAddress">
				<a-input  v-model="editModel.deviceAddress"/>
			</a-form-model-item>
			<a-form-model-item label="设备IMEI" prop="imei">
				<a-input  v-model="editModel.imei"/>
			</a-form-model-item>
			<a-form-model-item label="设备IMSI" prop="imsi">
				<a-input  v-model="editModel.imsi"/>
			</a-form-model-item>
			<a-form-model-item label="设备ICCID" prop="iccid">
				<a-input  v-model="editModel.iccid"/>
			</a-form-model-item>
			<a-form-model-item label="安装地址" prop="installAddress">
				<a-input  v-model="editModel.installAddress"/>
			</a-form-model-item>
			<a-form-model-item label="备注信息" prop="remark">
				<a-textarea :rows="5" placeholder="最多200字" :max-length="200" v-model="editModel.remark"/>
			</a-form-model-item>
		</a-form-model>
		<div class="drawerFooter">
		    <a-button icon="close" @click="closeView(false)" style="margin-right: 0.625rem;">取 消</a-button>
		    <a-button  icon="check" type="primary" :loading="submitFlag" @click="onSubmit">提 交</a-button>
		</div>
	</a-drawer>
</template>

<script>
	export default {
		props: ['neighborList'],
		data(){
			return {
				showAddFlag:false,
				editModel:{
					neighborId:null,
					deviceAddress:null,
					imei:null,
					imsi:null,
					iccid:null,
					installAddress:null,
					remark:null,
				},
				submitFlag:false,
				rules:{
					neighborId:[{required:true,message:'请选择小区',trigger: 'blur'},],
					deviceAddress:[{required:true,message:'请输入采集器地址',trigger: 'blur'}],
				}, 
			}
		},
		methods: {
			filterOption(input, option) {
				return (option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0);
			},
			showView(item){
				this.showAddFlag = true;
				this.editModel = this.Config.deepClone(item);
			},
			closeView(flag) {
				if(flag){
					this.$emit('successHandler');
				}
				this.showAddFlag = false;
			},
			onSubmit(){
				this.$refs.addForm.validate(valid => {
					if(valid) {
						this.doSubmit();
					} else {
						return false;
					}
				});
			},
			doSubmit:function(){
				this.submitFlag = true;
				let url = this.Api.getLastUrl(this.Api.UPDATE_DY_4G_COLLECT_URL);
				this.Api.fetchPostWithForm(url,this.editModel).then((data)=>{
					this.submitFlag = false;
					let code = data.data.code;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.closeView(true);
						this.$message.success('新增4G采集设备成功');
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
					this.submitFlag = false;
				})
			},
		},
	}
</script>

<style>
</style>
